import { useGetIdentity, useListContext, useTranslate } from "ra-core";
import { List } from "@/components/admin/list";

import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { useConfigurationContext } from "../root/ConfigurationContext";
import type { Deal } from "../types";
import { DealCardContent } from "./DealCard";
import { DealEmpty } from "./DealEmpty";
import { getDealsByStage } from "./stages";

export const DealListMobile = () => {
  const { identity } = useGetIdentity();
  if (!identity) return null;
  return (
    <List
      title={false}
      perPage={100}
      filter={{ "archived_at@is": null }}
      sort={{ field: "index", order: "ASC" }}
      pagination={null}
      actions={false}
    >
      <DealListMobileLayout />
    </List>
  );
};

const DealListMobileLayout = () => {
  const { data, isPending } = useListContext<Deal>();
  const { dealStages, currency } = useConfigurationContext();
  const translate = useTranslate();

  if (isPending) return null;
  if (!data?.length) return <DealEmpty />;

  const dealsByStage = getDealsByStage(data, dealStages);

  return (
    <>
      <MobileHeader>
        <h1 className="text-xl font-semibold">
          {translate("resources.deals.name", { smart_count: 2 })}
        </h1>
      </MobileHeader>
      <MobileContent>
        <div className="flex flex-col gap-6">
          {dealStages.map((stage) => {
            const deals = dealsByStage[stage.value] ?? [];
            if (!deals.length) return null;

            const stageTotal = deals.reduce(
              (sum, deal) => sum + (deal.amount ?? 0),
              0,
            );
            const formattedTotal = stageTotal.toLocaleString("en-US", {
              notation: "compact",
              style: "currency",
              currency,
              currencyDisplay: "narrowSymbol",
              minimumSignificantDigits: 3,
            });

            return (
              <div key={stage.value} className="flex flex-col gap-2">
                <div className="flex items-center justify-between px-1">
                  <span className="text-sm font-medium">{stage.label}</span>
                  <span className="text-xs text-muted-foreground">
                    {formattedTotal}
                  </span>
                </div>
                {deals.map((deal) => (
                  <DealCardContent key={deal.id} deal={deal} />
                ))}
              </div>
            );
          })}
        </div>
      </MobileContent>
    </>
  );
};
